// Trying to keep most external links (ex. landing pages) in this page so we don't repeat them
// and have an easy inventory of what the site links off to
const ExternalLinks = {
  // Destinations
  CollabHotelCompTemplate: "https://shrpa.com/resources/destination/requesting-hotel-comps/",
  WebsiteIntegrations: "https://shrpa.com/resources/destination/website-integrations/",
  // Creators
  ForCreators: "https://shrpa.com/resources/creator/start-today/",
  BecomingACreator: "https://shrpa.com/resources/creator/start-today/",
  CollabGuidance: "https://shrpa.com/resources/guides/creator/collabs/",
  CollabSocialPostTips: "https://shrpa.com/resources/guides/creator/social-post/",
  ConvertingHeicToJpeg: "https://shrpa.com/resources/creator/heic-to-jpg/",
  // Creator Slack we set up (should be set to never expire)
  SlackCreatorInvite: "https://join.slack.com/t/shrpacreators/shared_invite/zt-2p554wlo4-EEbxT6c9j5J4PNxY2iLQ3w",
  // Social
  Instagram: "https://instagram.com/tryshrpa/",
  Facebook: "https://facebook.com/tryshrpa",
} as const;

/* Old deprecated links
   Keeping these here in case we want to know where the wordpress pages were linked from.

   // ForCommunities: "https://explore.shrpa.com/community-intro/", // homepage covers this now
   // CustomerContactUs: "https://explore.shrpa.com/contact-sales/",
   // CollabExpectations: "https://explore.shrpa.com/collaboration-expectations/",
   // PhotoWallIntro: "https://explore.shrpa.com/photo-walls-delivering-inspiration/",
   // CommunityPaidCollabOverview: "https://explore.shrpa.com/support/communities/paid-collaborations/how-does-setting-up-collaborations-work/",
   // CreatingAdventureTips: "https://explore.shrpa.com/creating-adventures/", // Creator Dash Help Link
   // BecomingAPaidCreator: "https://explore.shrpa.com/join-the-shrpa-travel-network/", // Learn More when asking about paid creator interest
   // CreatorCollabAdvExp: // Formerly "https://explore.shrpa.com/creating-quality-adventures-for-collaborations/",
   // CreatorReferralProgram: "https://explore.shrpa.com/referral-program",
   // CollabCreditsSummary: "https://explore.shrpa.com/collaboration-credits",
   // AvailableCollabsSummary: "https://explore.shrpa.com/creator-collaborations/",
   // AdventureCreationTips: "https://explore.shrpa.com/creating-adventures/",
   // WebsiteIntegrations: "https://explore.shrpa.com/integrations/how-to-integrate-adventures-on-your-site/",
*/

export function getGlobalLink(key: ExternalLinksKey): string {
  return ExternalLinks[key];
}

type ExternalLinksKey = keyof typeof ExternalLinks;

export default {
  ExternalLinks,
};
